import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-[#0A192F]">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <Logo dark />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Il tuo punto di riferimento per utenze, credito e assicurazioni. Semplice, chiaro, umano.
            </p>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Servizi</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li><Link to="/utenze" className="transition-colors hover:text-[#10B981]">Utenze</Link></li>
              <li><Link to="/credito" className="transition-colors hover:text-[#10B981]">Credito</Link></li>
              <li><Link to="/assicurazioni" className="transition-colors hover:text-[#10B981]">Assicurazioni</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">ViviTranquillo</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li><Link to="/piano" className="transition-colors hover:text-[#10B981]">Piano ViviTranquillo</Link></li>
              <li><Link to="/registrazione" className="transition-colors hover:text-[#10B981]">Registrati</Link></li>
              <li><Link to="/login" className="transition-colors hover:text-[#10B981]">Area Clienti</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Contatti</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li><a href="mailto:servizioclienti@vivitranquillo.com" className="transition-colors hover:text-[#10B981]">servizioclienti@vivitranquillo.com</a></li>
              <li>PEC: hyperconsult@pec.it</li>
              <li>Assistenza durante tutto l'anno</li>
            </ul>
            <h4 className="mt-6 font-display text-sm font-bold uppercase tracking-wider text-white">Legale</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li><Link to="/termini" data-testid="footer-link-termini" className="transition-colors hover:text-[#10B981]">Termini e Condizioni</Link></li>
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="transition-colors hover:text-[#10B981]">Privacy Policy</Link></li>
              <li><Link to="/cookie" data-testid="footer-link-cookie" className="transition-colors hover:text-[#10B981]">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-slate-500 md:flex-row md:items-center">
          <div className="space-y-1">
            <p>© {new Date().getFullYear()} ViviTranquillo — Hyper Consult SRL. Tutti i diritti riservati.</p>
            <p>Via Caldera 21, 20153 Milano (MI) · P.IVA / C.F. 14302280962 · REA MI-2773920</p>
          </div>
          <p>I preventivi assicurativi sono gratuiti e separati dal Piano ViviTranquillo.</p>
        </div>
      </div>
    </footer>
  );
}
